var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgBullhorn(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M23.622 3.469l-.516.515a14.586 14.586 0 01-9.984 4.266v6.047c3.75.047 7.313 1.594 9.984 4.265l.516.516V3.468zm-12.75 2.53h1.875c3.281 0 6.422-1.265 8.766-3.608l1.78-1.782c.938-.937 2.58-.28 2.58 1.078v6.75c.843.422 1.5 1.547 1.5 2.813 0 1.312-.657 2.437-1.5 2.86v6.75c0 1.359-1.642 2.015-2.58 1.077l-1.78-1.78c-2.25-2.25-5.25-3.563-8.39-3.61v4.828c0 1.453-1.22 2.625-2.626 2.625h-1.5a2.62 2.62 0 01-2.625-2.625V16.5c-1.687 0-3-1.313-3-3V9c0-1.64 1.313-3 3-3h4.5zm-2.25 10.5v4.876c0 .234.14.375.375.375h1.5a.37.37 0 00.375-.375V16.5h-2.25zm-2.25-8.25c-.422 0-.75.376-.75.75v4.5c0 .423.328.75.75.75h4.5v-6h-4.5z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgBullhorn);
export default ForwardRef;
